import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import PicError from '@/assets/images/pic_error.png'
import PicLoad from '@/assets/images/pic_load.png'

export default ({ style = {}, ...props }: any) => {
  const { display = '' } = style
  const [state, setState] = useState(false)
  const [errorState, setErrorState] = useState(false)
  const load = () => {
    setState(true)
  }

  const error = () => {
    setErrorState(true)
  }

  return (
    <React.Fragment>
      <img {...props} style={{ ...style, display: state ? display || '' : 'none' }} onLoad={load} onError={error} />
      {!state && !errorState ? <img {...props} style={{ ...style, margin: '0 auto', width: 'auto', display }} src={PicLoad} alt="ImgPlaceholder" /> : null}
      {errorState ? <img {...props} style={{ ...style, margin: '0 auto', width: 'auto', display }} src={PicError} alt="ImgPlaceholder" /> : null}
    </React.Fragment>
  )
}
